<h2 mat-dialog-title>
  <div *ngIf="OpenFrom=='ReadyToSign'" class="task-list-header">
    <span class="dialog-title">Ready to sign</span>
  </div>
  <div *ngIf="OpenFrom=='Pending'" class="task-list-header">
    <span class="dialog-title">Pending</span>
  </div>
  <div *ngIf="OpenFrom=='Drafts'" class="task-list-header">
    <span class="dialog-title">Drafts</span>
  </div>
  <button mat-icon-button class="close-button" (click)="closeTask()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <div *ngIf="OpenFrom=='ReadyToSign'" class="tabledata">
    <table cellspacing="0" cell padding="0">
      <tr>
        <th class="sub bnone">Subject</th>
        <th class="status bnone">Relation</th>
        <th class="act bnone">Action</th>
      </tr>
      <ng-container *ngFor="let inbox of inboxProjectsList; let inboxIndex = index">
        <ng-container *ngIf="(inbox.status == 0 || inbox.status == 2) && inboxIndex <= 15">
          <tr>
            <td class="sub">
              <div class="cUsrImg">
                <span>{{ inbox.subject }}</span>
              </div>
            </td>
            <td class="status" *ngIf="inbox.relationName">
              {{ inbox.relationName }}
            </td>
            <td class="status" *ngIf="!inbox.relationName">
              - 
            </td>
            <td class="act">
              <a *ngIf="inbox.status==0" mat-icon-button matTooltipClass="tooltip" target="_blank"
                [href]='inbox.signHref' matTooltip="Sign" color="primary">
                <mat-icon>border_color</mat-icon>
              </a>

              <a *ngIf="inbox.status==2" mat-icon-button matTooltipClass="tooltip" target="_blank"
                [href]='inbox.signHref' matTooltip="Approve" color="primary">
                <mat-icon>check_circle</mat-icon>
              </a>

            </td>
          </tr>
        </ng-container>
        <tr *ngIf="(inbox.status == 0 || inbox.status == 2) && inboxIndex == 16">

          <td colspan="3" class="viewall">
            <a (click)="ViewAll('inbox')">View all</a>
            <!-- <a [routerLink]="'/esignature/inbox'">View all</a> -->
          </td>

        </tr>
      </ng-container>

      <tr *ngIf="noRecordFoundInbox">
        <td class="noRecordFound" colspan="3">No Record Found</td>
      </tr>
    </table>
  </div>

  <div *ngIf="OpenFrom=='Pending'" class="tabledata">
    <table cellspacing="0" cellpadding="0">
      <tr>
        <th class="sub bnone">Subject</th>
        <th class="sub bnone">Date</th>
        <th class="status bnone">Status</th>
        <th class="act bnone">Action</th>
      </tr>
      <ng-container *ngFor="let sent of sentProjectsList; let sentIndex = index">
        <ng-container *ngIf="sentIndex <= 15">
          <tr>
            <td class="sub">
              <div class="cUsrImg">
                <span>{{ sent.subject }}</span>
              </div>
            </td>
             <td class="sub">
              <div class="cUsrImg">
                <span>{{ sent.createdOn| date: "MM/dd/yyyy" }}</span>
              </div>
            </td>
            <td class="status">
              <p *ngIf="sent.status==0">Drafted</p>
              <p *ngIf="sent.status==1">Mail Sent</p>
              <p *ngIf="sent.status==2">In-progress</p>
              <p *ngIf="sent.status==3">Completed</p>
              <p *ngIf="sent.status==4">Withdraw</p>
              <p *ngIf="sent.status==5">Declined</p>
            </td>
            <td class="act">
              <button mat-icon-button (click)='OpenDetailsSent(sent)'>
                <mat-icon>launch</mat-icon>
              </button>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="sentIndex == 16">
          <td colspan="3" class="viewall">
            <!-- <a [routerLink]="'/esignature/sent'">View all</a> -->
            <a (click)="ViewAll('sent')">View all</a>
          </td>

        </tr>
      </ng-container>


      <tr *ngIf="noRecordFoundSent">
        <td class="noRecordFound" colspan="3">No Record Found</td>
      </tr>
    </table>
  </div>

  <div *ngIf="OpenFrom=='Drafts'" class="tabledata">
    <table cellspacing="0" cell padding="0">
      <tr>
        <th class="sub bnone">Type</th>
        <th class="sub bnone">Project Name</th>
        <th class="status bnone">Steps</th>
        <th class="act bnone">Link</th>
      </tr>
      <ng-container *ngFor="let draft of draftProjectsList; let draftIndex = index">
        <tr *ngIf="draftIndex <= 15">
          <td class="sub">
            <img *ngIf="draft.projectType != 2" src="../../../../assets/images/icons/formIcon.svg" alt="" width="30" />
            <img *ngIf="draft.projectType == 2" src="../../../../assets/images/icons/form_tabuler.svg" alt=""
              width="30" />
          </td>

          <td class="sub">
            <div class="cUsrImg">
              <span style="width: 150px;">{{ draft.projectName }}</span>
            </div>
          </td>
          <td class="status">
            <p class="showSteps" *ngIf="draft.projectType!= 2">
              <ng-container *ngIf="draft.stepCompleted == 0 || draft.stepCompleted == 1">
                <span class="active"></span>
                <span></span>
                <span></span>
                <span></span>
              </ng-container>
              <ng-container *ngIf="draft.stepCompleted == 2">
                <span class="active"></span>
                <span class="active"></span>
                <span></span>
                <span></span>
              </ng-container>
              <ng-container *ngIf="draft.stepCompleted == 3">
                <span class="active"></span>
                <span class="active"></span>
                <span class="active"></span>
                <span></span>
              </ng-container>
              <ng-container *ngIf="draft.stepCompleted == 4">
                <span class="active"></span>
                <span class="active"></span>
                <span class="active"></span>
                <span class="active"></span>
              </ng-container>

            </p>
            <p class="showSteps" *ngIf="draft.projectType== 2">
              <ng-container>
                <span class="active"></span>
                <span class="active"></span>
              </ng-container>
            </p>
          </td>
          <td class="act">
            <button *ngIf="draft.projectType != 2" mat-icon-button (click)='OpenProjectDeatils(draft)'>
              <mat-icon>launch</mat-icon>
            </button>
            <button *ngIf="draft.projectType == 2" mat-icon-button (click)='OpenTablarDeatils(draft)'>
              <mat-icon>launch</mat-icon>
            </button>
          </td>
        </tr>
        <tr *ngIf="draftIndex == 16">
          <td colspan="3" class="viewall">
            <!-- <a [routerLink]="'/esignature/draft'">View all</a> -->
             <a (click)="ViewAll('draft')">View all</a>
          </td>

        </tr>
      </ng-container>

      <tr *ngIf="noRecordFounddraft">
        <td class="noRecordFound" colspan="3">No Record Found</td>
      </tr>

    </table>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="closeTask()">
    Cancel
  </button>
</mat-dialog-actions>